import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';



// CHD Need to initilize in first, because, all Provider use it...

import firebase from 'firebase';

 // Initialize Firebase
var config = {
  apiKey: "AIzaSyDzsKhs8b2KwuDbhFrJMQSfKG8moLw15MQ",
  authDomain: "gvtcloudconnection.firebaseapp.com",
  databaseURL: "https://gvtcloudconnection.firebaseio.com",
  projectId: "gvtcloudconnection",
  storageBucket: "gvtcloudconnection.appspot.com",
  messagingSenderId: "318112417231"
};
firebase.initializeApp(config);

// CHD end



platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts